import React from 'react';
import {CurrencyMenuItem} from '@homeaway/react-currency-switcher';
import {SVGIcon} from '@homeaway/react-svg';
import {CHEVRON_RIGHT__16} from '@homeaway/svg-defs';
import {namedEvents, linkLocations} from '../../../utils/edap';
import {TrackingContext} from '@homeaway/react-event-tracking';

export class CurrencyMenuItemsWrapper extends React.Component {
    constructor(props) {
        super(props);
        this.handleShowAllCurrenciesClick = this.handleShowAllCurrenciesClick.bind(this);
        this.handleCurrencySelectorChange = this.handleCurrencySelectorChange.bind(this);
        this.triggerCurrencySelectionEvent = this.triggerCurrencySelectionEvent.bind(this);
    }

    static contextType = TrackingContext;

    triggerCurrencySelectionEvent(currencyCode) {
        if (this.props.isTopCurrenciesView) {
            this.context.trigger(namedEvents.CURRENCY_SELECTED, {
                action_location: linkLocations.SIDEBAR_TOP_CURRENCY_LIST,
                displaycurrency: this.props.selectedCurrency,
                selected_display_currency: currencyCode
            });
            this.context.trigger(namedEvents.CURRENCY_UPDATED, {
                action_location: linkLocations.SIDEBAR_TOP_CURRENCY_LIST,
                displaycurrency: this.props.selectedCurrency,
                selected_display_currency: currencyCode
            });
        } else {
            this.context.trigger(namedEvents.CURRENCY_SELECTED, {
                action_location: linkLocations.SIDEBAR_ALL_CURRENCY_LIST,
                displaycurrency: this.props.selectedCurrency,
                selected_display_currency: currencyCode
            });
            this.context.trigger(namedEvents.CURRENCY_UPDATED, {
                action_location: linkLocations.SIDEBAR_ALL_CURRENCY_LIST,
                displaycurrency: this.props.selectedCurrency,
                selected_display_currency: currencyCode
            });
        }
    }
    handleShowAllCurrenciesClick() {
        this.props.handleShowAllCurrenciesClick();
    }
    handleCurrencySelectorChange(e) {
        this.props.onCurrencySelectorChange(e.currentTarget.dataset.currencyCode);
    }
    renderItem = (item) => {
        return (
            <div
                className="site-header-tray__menu-item-link"
                key={item.code}
                data-currency-code={item.code}
                onClick={this.handleCurrencySelectorChange}
                onKeyPress={this.handleCurrencySelectorChange}
                role={'menuitem'}
            >
                <CurrencyMenuItem
                    currencyCode={item.code}
                    currencySymbol={item.symbol}
                    currencyName={item.name}
                    isActive={this.props.selectedCurrency === item.code}
                    eventTrigger={this.triggerCurrencySelectionEvent}
                />
            </div>
        );
    }

    render() {
        const {currencyList, isTopCurrenciesView, translations: {showAllCurrenciesText}} = this.props;
        return (
            <div className="site-header-tray__menu site-header-tray__drawer">
                <div className="site-header-tray__items">
                    {currencyList.map(this.renderItem)}
                </div>
                {isTopCurrenciesView &&
                    <div
                        className="site-header-tray__items"
                        onClick={this.handleShowAllCurrenciesClick}
                        role={'menuitem'}
                    >
                        <div className="site-header-tray__menu-item-link">
                            <span className="site-header-tray__menu-item-link--all-currencies-link">
                                {showAllCurrenciesText}
                                <SVGIcon className="text-muted" inline markup={CHEVRON_RIGHT__16} />
                            </span>
                        </div>
                    </div>
                }
            </div>
        );
    }
}
